import React, { useEffect } from 'react';
import { Alert, Backdrop, ButtonBase, CircularProgress } from '@mui/material';
import styled from '@mui/material/styles/styled';
import './App.css';
import Axios from 'axios';
import { useState } from 'react';
import qs from 'qs';
import { useLocation, useMatch, useRoutes } from 'react-router';




const AppContainer = styled("div")(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  minWidth: '100vw',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
}));
const LoadingBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.tooltip + 1,
  color: 'white',
}));
const PageLogo = styled('img')(({ theme }) => ({
  width: 150,
  height: 150,
  borderRadius: '100%',
  boxShadow: theme.shadows[1],
  objectFit: 'contain',
  backgroundColor: 'white',
  marginBottom: theme.spacing(2),
}));
const PageName = styled('div')(({ theme }) => ({
  fontSize: 24,
}));
const PageLinksContainer = styled('div')(({ theme }) => ({
  // width: '100%',
  margin: theme.spacing(2),
  display: 'grid',
  gap: theme.spacing(2),
  maxWidth: 400,
}));
const LinkContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  border: '1px solid #ccc',
  padding: theme.spacing(1),
  gap: theme.spacing(1),
  borderRadius: theme.shape.borderRadius
}));
const LinkIcon = styled('img')(({ theme }) => ({
  width: 50,
  height: 50,
  borderRadius: '100%',
  boxShadow: theme.shadows[1]
}));
const LinkName = styled('div')(({ theme }) => ({
  fontSize: 18,
  textAlign: 'start',
  lineHeight: 1.5,
}));
const LinkBase = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  flexGrow: 1,
}));
const LinkUrl = styled('a')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
}));




const CancelToken = Axios.CancelToken;
let source = CancelToken.source();

const App = (props) => {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState({});
  const [error, setError] = useState(false);

  const match = useLocation();
  console.log(match);

  const getPage = async () => {
    let data = {
      request: "getLinkTreePage",
      slug: match.pathname,
    }
    source.cancel();
    source = CancelToken.source();
    let response = await Axios.post('https://api.adwhitlojistik.com/webapp/general.php', qs.stringify(data), {
      cancelToken: source.token,
    });

    if (response.data.status === 'success') {
      setPage(response.data.page);
      document.title = response.data.page.title;
    } else {
      setError('لم يتم العثور على الصفحة المطلوبة');
    }
    setLoading(false);

  }

  const handleClickLink = async (id) => {
    let data = {
      request: "clickLinkTree",
      id,
    }
    Axios.post('https://api.adwhitlojistik.com/webapp/general.php', qs.stringify(data));
  }

  useEffect(() => {
    getPage();
  }, []);
  return <AppContainer>
    <LoadingBackdrop open={loading}><CircularProgress color="inherit" /></LoadingBackdrop>
    {error && <Alert severity="error">{error}</Alert>}
    {page != null && !error && <>


      <PageLogo src={page.logo} alt={page.title} />
      <PageName>{page.title}</PageName>

      <PageLinksContainer>
        {page?.links?.map((lnk, ind) => {
          return <LinkUrl onClick={() => {
            handleClickLink(lnk.id);
          }} target="_blank" href={lnk.url} key={`lnk${ind}`}>
            <LinkBase>
              <LinkContainer>
                <LinkIcon src={lnk.icon} />
                <LinkName>{lnk.name}</LinkName>
              </LinkContainer>
            </LinkBase>
          </LinkUrl>
        })}

      </PageLinksContainer>

    </>}
  </AppContainer>;
}

export default App;
